import React from 'react';

type Props = { children: React.ReactNode };
type State = { hasError: boolean; message?: string };

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: unknown): State {
    const message = error instanceof Error ? error.message : String(error);
    return { hasError: true, message };
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo) {
    // Log para inspeção durante desenvolvimento
    console.error('App error boundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 16, fontFamily: 'system-ui' }}>
          <h1>Ocorreu um erro ao carregar o app.</h1>
          {this.state.message && <p>Detalhes: {this.state.message}</p>}
          <p>Tente atualizar a página. Se persistir, me envie um print do console.</p>
        </div>
      );
    }
    return this.props.children;
  }
}